import { useEffect, useState } from 'preact/hooks'

const smallScreenMediaQuery = '(max-width: 36rem)'

export function useIsMobile(): boolean {
  const [isSmallScreen, setIsSmallScreen] = useState(
    () => window.matchMedia(smallScreenMediaQuery).matches,
  )

  useEffect(() => {
    const mediaQuery = window.matchMedia(smallScreenMediaQuery)
    const handleChange = () => setIsSmallScreen(mediaQuery.matches)

    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  return isSmallScreen
}
